import { useGetContext } from '../../api/lending/lapiHooks';

export function useSoleTraderPilot() {
  const { context } = useGetContext();

  return context.isOnSoleTraderPilot;
}
